<script>
import {
  SCHOOL_DISPLAY_STATUS_HIDDEN,
  SCHOOL_DISPLAY_STATUS_VISIBLE,
  SCHOOL_LINK_STATUS_LINKED,
  SCHOOL_LINK_STATUS_NOT_LINKED,
  SchoolClassification,
  StatusSchool,
  SchoolType
} from "@/core/option/schoolLinkSource";
import _debounce from "lodash/debounce";

const defaultForm = () => ({
  name: null,
  province_id: null,
  school_type: null,
  classify: null,
  // district_id: null,
  action: SCHOOL_DISPLAY_STATUS_VISIBLE,
  business_coefficient: 0,
  school_rate: 0,
  source: null,
})

const sourceOptions = [
  {value: 1, label: "Voucher"},
  {value: 2, label: "Đội kinh doanh"},
  {value: 3, label: "Digital"},
]

export default {
  name: "SchoolLinkForm",
  props: {
    provinces: {
      type: Array,
      default() {
        return []
      }
    },
    initialValue: {
      type: Object,
      default() {
        return null
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitText: {
      type: String,
      default: "Thêm mới"
    },
    cancelText: {
      type: String,
      default: "Đóng"
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: defaultForm(),
      schoolTypeOptions: SchoolType,
      schoolClassificationOptions: SchoolClassification,
      SCHOOL_DISPLAY_STATUS_VISIBLE,
      SCHOOL_DISPLAY_STATUS_HIDDEN,
      sourceOptions,
      // districts: [],
      // districtLoading: false,
    }
  },
  computed: {
    normalizedStatus() {
      return this.normalizeStatusValue(this.initialValue?.status);
    },
    canEditLinkInfo() {
      return this.isEdit && String(this.normalizedStatus) === String(SCHOOL_LINK_STATUS_LINKED);
    }
  },
  watch: {
    initialValue: {
      immediate: true,
      handler() {
        this.fillForm();
      }
    }
  },
  created() {
    this.debouncedSubmit = _debounce(this.submitForm, 500);
  },
  methods: {
    resetForm() {
      this.form = defaultForm();
      // this.districts = [];
      this.$refs.form?.reset();
    },
    fillForm() {
      const school = this.initialValue;

      if (!school) {
        this.form = defaultForm();
        return;
      }

      this.form = {
        name: school.name ?? null,
        province_id: school.province_id ?? school.province?.id ?? null,
        school_type: school.school_type ?? school.school_type_id ?? school.type_school ?? school.type_school_id ?? null,
        classify: school.classify ?? school.classification ?? school.classification_id ?? school.school_classification ?? school.school_classification_id ?? null,
        action: this.normalizeDisplayValue(school),
        business_coefficient: this.getBusinessCoefficient(school),
        school_rate: this.getSchoolRate(school),
        source: this.getSource(school),
      }

      // if (this.form.province_id) {
      //   this.getDistrictsByProvince(this.form.province_id);
      // }
    },
    normalizeDisplayValue(school) {
      const value = school.action ?? school.display ?? school.display_status ?? school.visible ?? school.is_visible;

      if (typeof value === "boolean") {
        return value ? SCHOOL_DISPLAY_STATUS_VISIBLE : SCHOOL_DISPLAY_STATUS_HIDDEN;
      }

      return value ?? SCHOOL_DISPLAY_STATUS_VISIBLE;
    },
    normalizeStatusValue(status) {
      return StatusSchool.find((option) => String(option.value) === String(status) || option.name === status)?.value ?? status;
    },
    getBusinessCoefficient(school) {
      if (String(this.normalizeStatusValue(school.status)) === String(SCHOOL_LINK_STATUS_NOT_LINKED)) {
        return 0;
      }

      return school.business_coefficient ?? 0;
    },
    getSchoolRate(school) {
      if (String(this.normalizeStatusValue(school.status)) === String(SCHOOL_LINK_STATUS_NOT_LINKED)) {
        return 0;
      }

      return school.school_rate ?? 0;
    },
    getSource(school) {
      if (String(this.normalizeStatusValue(school.status)) === String(SCHOOL_LINK_STATUS_NOT_LINKED)) {
        return null;
      }

      return school.source ?? null;
    },
    buildPayload() {
      const payload = {
        name: this.form.name,
        province_id: this.form.province_id,
        school_type: this.form.school_type,
        classify: this.form.classify,
        action: this.form.action,
      }

      if (this.canEditLinkInfo) {
        payload.business_coefficient = this.form.business_coefficient;
        payload.school_rate = this.form.school_rate;
        payload.source = this.form.source;
      }

      return payload;
    },
    submitForm() {
      this.$emit("submit", this.buildPayload());
    },
    // changeProvince(provinceId) {
    //   this.form.district_id = null;
    //   this.districts = [];
    //
    //   if (provinceId) {
    //     this.getDistrictsByProvince(provinceId);
    //   }
    // },
    // getDistrictsByProvince(provinceId) {
    //   this.districtLoading = true;
    //   this.$store.dispatch(GET_DISTRICTS_BY_PROVINCE, provinceId).then((res) => {
    //     this.districts = Array.isArray(res) ? res : res?.data ?? [];
    //   }).catch(() => {
    //     this.districts = [];
    //   }).finally(() => {
    //     this.districtLoading = false;
    //   })
    // },
    cancel() {
      this.$emit("cancel");
    }
  }
}
</script>

<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="form">
    <form class="form" @submit.prevent autocomplete="off">
      <div class="row">
        <div class="col-lg-6 col-xs-12">
          <p>Tên trường <span class="text-danger">*</span></p>
          <ValidationProvider name="Tên trường" :rules="{max:100,required:true}" v-slot="{ errors }" vid="title">
            <el-input placeholder="Nhập tên trường" v-model="form.name" />
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-lg-6 col-xs-12">
          <p>Tỉnh/Thành Phố <span class="text-danger">*</span></p>
          <ValidationProvider name="Tỉnh/Thành Phố" rules="required" v-slot="{ errors }" vid="title1">
            <el-select v-model="form.province_id" placeholder="Chọn Tỉnh/Thành Phố" clearable style="width: 100%" filterable @change="changeProvince">
              <el-option
                  v-for="item in provinces"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-lg-6 col-xs-12 mt-2">
          <p>Loại trường <span class="text-danger">*</span></p>
          <ValidationProvider vid="school_type" name="Loại trường" rules="required" v-slot="{ errors }">
            <el-select v-model="form.school_type" placeholder="Chọn loại trường" clearable style="width: 100%" filterable>
              <el-option
                  v-for="item in schoolTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="school_type" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-lg-6 col-xs-12 mt-2">
          <p>Phân loại <span class="text-danger">*</span></p>
          <ValidationProvider vid="classify" name="Phân loại" rules="required" v-slot="{ errors }">
            <el-select v-model="form.classify" placeholder="Chọn phân loại" clearable style="width: 100%" filterable>
              <el-option
                  v-for="item in schoolClassificationOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
            <div class="fv-plugins-message-container">
              <div data-field="classify" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </div>
        <div class="col-lg-6 col-xs-12 mt-2">
          <p>Hiển thị</p>
          <el-switch
              v-model="form.action"
              :active-value="SCHOOL_DISPLAY_STATUS_VISIBLE"
              :inactive-value="SCHOOL_DISPLAY_STATUS_HIDDEN"
              active-color="#13ce66"
          />
        </div>
        <div v-if="isEdit" class="col-lg-6 col-xs-12 mt-2">
          <p>Hệ số kinh doanh</p>
          <el-input-number
              v-model="form.business_coefficient"
              controls-position="right"
              :step=".01"
              :disabled="!canEditLinkInfo"
              placeholder="Nhập hệ số kinh doanh"
              class="w-100"
          />
        </div>
        <div v-if="isEdit" class="col-lg-6 col-xs-12 mt-2">
          <p>Phần trăm nhà trường</p>
          <el-input-number
              v-model="form.school_rate"
              controls-position="right"
              :step="1"
              :max="100"
              :min="0"
              :disabled="!canEditLinkInfo"
              placeholder="Nhập phần trăm nhà trường"
              class="w-100"
          />
        </div>
        <div v-if="isEdit" class="col-lg-6 col-xs-12 mt-2">
          <p>Nguồn trích phần trăm</p>
          <el-select
              v-model="form.source"
              :disabled="!canEditLinkInfo"
              placeholder="Chọn nguồn trích phần trăm"
              clearable
              class="w-100"
          >
            <el-option
                v-for="item in sourceOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="d-flex d-flex flex-row-reverse mt-5">
        <button type="button" :disabled="loading" class="btn ml-4" style="background-color: #5D04B0;color: white" @click="handleSubmit(debouncedSubmit)">
          <i v-if="loading" class="el-icon-loading"></i> {{ submitText }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancel">{{ cancelText }}</button>
      </div>
    </form>
  </ValidationObserver>
</template>

<style scoped>
</style>
